let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kPLWf")).then(() => parcelRequire('2MQ7j'));